<template>
  <div class="login" @keyup.enter="login">
    <el-image class="side-bg" :src="url" fit="cover"></el-image>
    <div class="login-form">
      <div class="title">龙境安卓云系统管理软件</div>
      <div class="item" @click="focusInput('username')">
        <el-image class="icon" :src="usernameUrl" fit="fill"></el-image>
        <input ref="usernameInput" name="username" v-model="info.username" />
      </div>
      <div class="item" @click="focusInput('password')">
        <el-image class="icon" :src="passwordUrl" fit="fill"></el-image>
        <input ref="passwordInput" name="password" type="password" v-model="info.password" />
      </div>
      <div class="save-container" @click="handleSaveClick" v-if="!isMobile">
        <el-checkbox class="save" v-model="info.save">记住用户名</el-checkbox>
      </div>
      <el-button type="primary" class="login-btn" @click="login"
        :loading="$store.state.loginState">{{ $store.state.loginState ? '登录中' : '登录' }}</el-button>
    </div>
    <div class="copyright" v-if="!isMobile">版权所有©杭州龙境科技有限公司</div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      url: require('../assets/login/login-bg.png'),
      usernameUrl: require('../assets/login/icon_user.png'),
      passwordUrl: require('../assets/login/icon_user-02.png'),
      info: {
        username: "",
        password: "",
        save: false
      },
      isMobile: false
    }
  },
  methods: {
    login() {
      let loginInfo = { ...this.info }
      loginInfo.password = md5(loginInfo.password)
      this.$store.dispatch(this.$action.LOGIN, loginInfo)
    },
    focusInput(type) {
      if (type === 'username' && this.$refs.usernameInput) {
        this.$refs.usernameInput.focus()
      } else if (type === 'password' && this.$refs.passwordInput) {
        this.$refs.passwordInput.focus()
      }
    },
    handleSaveClick(event) {
      // 防止事件冒泡，避免与el-checkbox的点击事件冲突
      event.stopPropagation()
      // 只有当点击的不是checkbox本身时才切换状态
      if (!event.target.matches('.el-checkbox__input, .el-checkbox__input *')) {
        this.info.save = !this.info.save
      }
    },
    detectMobile() {
      // 检测是否为移动设备
      const userAgent = navigator.userAgent.toLowerCase()
      const isMobile = /android|harmony|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
      // 或者通过屏幕宽度判断
      const isSmallScreen = window.innerWidth <= 768
      const isHarmony = /openharmony/.test(userAgent) && /phone|tablet/.test(userAgent)
      
      this.isMobile = isMobile || isSmallScreen || isHarmony
    },
    // iOS Safari 键盘缩放问题处理
    handleIOSZoom() {
      // 检测是否为iOS Safari
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      
      if (isIOS && isSafari) {
        // 监听输入框焦点事件
        const inputs = [this.$refs.usernameInput, this.$refs.passwordInput]
        
        inputs.forEach(input => {
          if (input) {
            // 输入框获得焦点时（键盘弹出）
            input.addEventListener('focus', () => {
              // 设置viewport为固定缩放，防止自动放大
              this.setViewportScale('0.999')
            })
            
            // 输入框失去焦点时（键盘关闭）
            input.addEventListener('blur', () => {
              // 延迟恢复viewport缩放
              setTimeout(() => {
                this.resetViewportScale()
              }, 300)
            })
          }
        })
      }
    },
    // 设置viewport缩放
    setViewportScale(scale) {
      const viewport = document.querySelector('meta[name="viewport"]')
      if (viewport) {
        viewport.setAttribute('content', `width=device-width, initial-scale=${scale}, maximum-scale=${scale}, user-scalable=no`)
      }
    },
    // 重置viewport缩放
    resetViewportScale() {
      const viewport = document.querySelector('meta[name="viewport"]')
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no')
      }
    }
  },
  mounted() {
    if (this.$route.query.from === "manage") {
      this.$store.commit(this.$mutation.MANAGE, 1)
    } else {
      this.$store.commit(this.$mutation.MANAGE, 0)
    }
    this.$store.commit(this.$mutation.LOGIN_STATE, false)

    if (this.$store.state.userInfo.save) {
      this.info.username = this.$store.state.userInfo.username
      this.info.save = true
    }
    this.$store.commit(this.$mutation.SSH_INFO, { show: false, start: false })
    // 检测是否为移动设备
    this.detectMobile()
    // 处理iOS Safari键盘缩放问题
    this.$nextTick(() => {
      this.handleIOSZoom()
    })
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 100vw;
  height: 100vh;
  // min-height: 800px;
  background: #f1f0f3;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.side-bg {
  width: 432px;
  height: 480px;
  object-fit: cover;
  border-radius: 15px 0 0 15px;
}

.login-form {
  background-color: white;
  width: 253px;
  height: 460px;
  padding: 20px 55px 0 60px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 0 15px 15px 0;
}

.title {
  color: #555;
  font-size: 24px;
  text-align: left;
  padding: 60px 0;
  border: none;
  white-space: nowrap;
}

.icon {
  flex-shrink: 0;
  width: 16px !important;
  height: 16px !important;
}

.save-container {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.save {
  text-align: left;
  padding: 10px 0;
  display: inline-block;
  width: 100%;
}

.item {
    display: flex;
    flex-direction: row;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    cursor: pointer;

    input {
      border: none;
      width: 100%;
      padding-left: 10px;
      background: transparent;
      border-radius: 0;
      /* iOS Safari 优化 */
      font-size: 16px; /* 防止iOS Safari自动缩放 */
      -webkit-appearance: none; /* 移除iOS默认样式 */
      -webkit-tap-highlight-color: rgba(0,0,0,0.1); /* 点击高亮 */
      -webkit-user-select: text; /* 允许文本选择 */
      user-select: text;
      /* 防止iOS Safari自动缩放 */
      transform: scale(1);
      transform-origin: 0 0;
    }

    input:focus {
      outline: none;
      /* iOS Safari 焦点状态优化 */
      -webkit-tap-highlight-color: rgba(0,0,0,0.1);
    }
  }

.login-btn {
  padding: 10px 0;
  font-size: 14px;
}

.copyright {
  position: absolute;
  bottom: 20px;
  color: #888;
  font-size: 14px;
}

span {
  border-color: #3d88fe !important;
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .login {
    min-height: 100vh;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 30px 20px;
    box-sizing: border-box;
  }

  .side-bg {
    width: 100%;
    max-width: 336px;
    height: auto;
    aspect-ratio: 324/360;
    border-radius: 15px 15px 0 0;
    margin: 0 auto;
  }

  .login-form {
    width: 100%;
    max-width: 336px;
    height: auto;
    padding: 20px;
    border-radius: 0 0 15px 15px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .title {
    font-size: 20px;
    padding: 10px 0 10px 0;
    text-align: center;
  }

  .item {
    // margin-bottom: 15px;
    min-height: 44px; /* iOS 推荐的最小点击区域 */
    align-items: center;
    
    input {
      font-size: 16px; /* iOS Safari 需要至少16px字体避免缩放 */
      min-height: 44px; /* iOS 推荐的最小点击区域 */
      padding: 0px 10px; /* 增加内边距 */
      -webkit-tap-highlight-color: rgba(0,0,0,0.1); /* 点击高亮 */
      -webkit-user-select: text; /* 允许文本选择 */
      user-select: text;
      -webkit-appearance: none; /* 移除iOS默认样式 */
      transform: scale(1);
      transform-origin: 0 0;
    }
  }

  .login-btn {
    margin-top: 10px;
    min-height: 44px; /* iOS 推荐的最小点击区域 */
    font-size: 16px;
  }

  .copyright {
    font-size: 12px;
    bottom: 10px;
  }
}

/* iOS Safari 特殊优化 - 仅针对iOS设备 */
@supports (-webkit-touch-callout: none) {
  .item input {
    font-size: 16px; /* iOS Safari 需要至少16px字体避免缩放 */
    min-height: 44px; /* iOS 推荐的最小点击区域 */
    -webkit-appearance: none; /* 移除iOS默认样式 */
  }
  
  
  .login-btn {
    min-height: 44px; /* iOS 推荐的最小点击区域 */
  }
}

/* 触摸设备优化 - 针对所有触摸设备，包括iOS和安卓 */
@media (hover: none) and (pointer: coarse) {
  .login {
    /* 防止双击缩放 */
    touch-action: manipulation;
    -ms-touch-action: manipulation;
  }
  
  .item {
    min-height: 44px;
    
    input {
      font-size: 16px;
      min-height: 44px;
      padding: 0px 10px;
      -webkit-tap-highlight-color: rgba(0,0,0,0.1); /* 点击高亮 */
      -webkit-user-select: text; /* 允许文本选择 */
      user-select: text;
      /* 触摸设备优化 */
      touch-action: manipulation;
      -ms-touch-action: manipulation;
    }
  }
  
  .login-btn {
    min-height: 44px;
    /* 触摸设备优化 */
    touch-action: manipulation;
    -ms-touch-action: manipulation;
  }
}

/* 防止iOS Safari双击缩放 */
html {
  touch-action: manipulation;
  -ms-touch-action: manipulation;
}

/* 防止iOS Safari长按选择文本 */
* {
  -webkit-touch-callout: none; /* 防止长按链接/图片弹出菜单 */
  -webkit-user-select: none; /* 防止文本选择 */
  user-select: none;
}

/* 允许输入框文本选择 */
input, textarea {
  -webkit-user-select: text !important;
  user-select: text !important;
}
</style>